import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import { AuthProvider } from './context/auth';
import Routes from './router/routes';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.REACT_APP_SUBDIRECTORY}>
        <QueryParamProvider adapter={ReactRouter5Adapter}>
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
          />
          <Routes />
        </QueryParamProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
